import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { Stock, StockLevelStatuses } from '@telialt/models/src/EshopModel';
import { withParams } from '@telialt/utils/src/helpers';

type Props = {
    stock: Stock;
};

export const ProductStockText: FC<Props> = ({ stock: { stockLevel, stockLevelStatus } }) => {
    const { t } = useTranslations();

    if (stockLevelStatus === StockLevelStatuses.NoStock) {
        return t['eshop.product_page.stock_status.out_of_stock'];
    } else if (stockLevel < 1) {
        return t['eshop.product_page.stock_status.no_stock_available'];
    } else if (stockLevel === 1) {
        return t['eshop.product_page.stock_status.one_left'];
    } else if (stockLevel > 1 && stockLevel <= 3) {
        return withParams(t['eshop.product_page.stock_status.low_stock'], { stockLevel });
    } else {
        return t['eshop.product_page.stock_status.full_stock'];
    }
};
